import React from "react";


function main() {
    return(
        <header className="App-header">
            <div className="Headline">
                <p>Front-End Developer</p>
            </div>
            <a
                className="App-link"
                href="#about"
                rel="noopener noreferrer"
            >
                view more
            </a>
        </header>
    )
}

export default main;